<template>
  <wui-modal
    :title="information"
    :size="40"
    :closable="false"
    class="!w-[350px] phone:!w-[320px]"
  >
    <p
      v-if="description"
      class="text-body-r-14-20 text-fg-base-fg10"
    >
      {{ description }}
    </p>

    <template #footer>
      <wui-btn
        :size="40"
        variant="neut"
        state="alpha"
        @click="closeModal(undefined)"
      >
        {{ $t('common.close') }}
      </wui-btn>
    </template>
  </wui-modal>
</template>
<script lang="ts" setup>
import { closeDialogKey, WuiBtn, WuiModal, safeInject } from '@wui/common-library'
import { onMounted } from 'vue'

const props = defineProps({
  information: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  timeout: {
    type: Number,
    default: 3000,
  },
  needToCloseOnTimeout: {
    type: Boolean,
    default: true,
  },
})
const closeModal = safeInject(closeDialogKey)

onMounted(() => {
  if (props.needToCloseOnTimeout) {
    setTimeout(() => closeModal(undefined), props.timeout)
  }
})
</script>
